import { Card, Col, Row, Tabs } from 'antd';
import { ConsignOrderGeneralData } from './ConsignOrderGeneralData';
import { ConsignProducts } from './ConsignProducts';
import { ConsignOrderMovements } from './ConsignOrderMovements';
import { consignmentOrderMovimientTypes } from '../../../../constants';

export const ConsignOrderModalBody = ({ data = {} }) => {
  const tabs = [
    {
      name: 'Productos',
      key: 'products',
      component: <ConsignProducts data={data} />,
    },
    {
      name: 'Bajas',
      key: 'movements',
      component: (
        <ConsignOrderMovements
          data={data}
          type={consignmentOrderMovimientTypes.drop}
        />
      ),
    },
    {
      name: 'Altas',
      key: 'movements-registration',
      component: (
        <ConsignOrderMovements
          data={data}
          type={consignmentOrderMovimientTypes.registration}
        />
      ),
    },
  ];

  return (
    <>
      <div className="site-card-wrapper">
        <Row gutter={16}>
          <Col span={8}>
            <ConsignOrderGeneralData data={data} />
          </Col>
          <Col span={16}>
            <Card bordered={true}>
              <Tabs type="line">
                {tabs.map(({ name, key, component: Component }) => {
                  return (
                    <Tabs.TabPane tab={name} key={key}>
                      {Component}
                    </Tabs.TabPane>
                  );
                })}
              </Tabs>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};
